import { useQuery } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { QUERY_KEYS } from '@/utils/query-keys';
import { CustomReportsService } from '@/infra/services/custom-reports';

interface GetTotalCreatedCustomReportsParams {
	organization_id: string;
	company_id?: string;
	sector_id?: string;
	line_id?: string;
	workstation_id?: string;
	start_date?: string;
	end_date?: string;
}

const Service = CustomReportsService.getInstance();

export const useGetTotalCreatedCustomReports = (params: GetTotalCreatedCustomReportsParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_TOTAL_CREATED_CUSTOM_REPORTS, params],
		queryFn: () => Service.getTotalReportsCreated(params),
		onError: () => {
			message.error(I18n.get('Error fetching total created custom reports'));
		}
	});
};
